module.exports = __webpack_public_path__ + "img/menusano-logo-nutrition-tech.4497bcf8.png";